import {Trans} from 'react-i18next'
import messages from '../../../assets/messages'
import {LEVEL_COLORS} from '../constants'
import {Legend, LegendItem, LegendTitle, Swatch} from './NetworkLegend.styled'

/**
 * Colour key explaining the per-level accent colours used across the offers tree
 * (Master MM, Agent levels 1-2, level 3+). Takes no props.
 */
export const NetworkLegend = () => {
  const items = [
    {color: LEVEL_COLORS[0], message: messages.pammLegendMasterMm},
    {color: LEVEL_COLORS[1], message: messages.pammLegendLevel1},
    {color: LEVEL_COLORS[2], message: messages.pammLegendLevel2},
    {color: LEVEL_COLORS[3], message: messages.pammLegendLevel3},
  ]

  return (
    <Legend>
      <LegendTitle>
        <Trans {...messages.pammLegendTitle} />
      </LegendTitle>
      {items.map((item) => (
        <LegendItem key={item.message.i18nKey}>
          <Swatch style={{backgroundColor: item.color}} />
          <Trans {...item.message} />
        </LegendItem>
      ))}
    </Legend>
  )
}
